exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ft11[data-v-69511034] {\n    font-size: 11px;\n}\n.notice[data-v-69511034] {\n    height: 28px;\n    line-height: 28px;\n    background-color: #ddeff9;\n    color: #1a96d4;\n}\n.bindshop p img[data-v-69511034] {\n    width: 13px;\n}\n.bind_code[data-v-69511034] {\n    width: 175px;\n    margin: 30% auto 0;\n}\n.oprate[data-v-69511034] {\n    margin: 30px 0;\n}\n.oprate span[data-v-69511034] {\n    border: solid 1px #e7e7e7;\n    padding: 7px 45px;\n}\n.btn_bg[data-v-69511034] {\n    background-color: #1a96d4;\n    border: none !important;\n}\n", ""]);

// exports
